import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountType } from 'app/modules/main/models/account';
import { Access } from 'app/modules/main/models/authorization';
import { AccountPermissions } from 'app/modules/main/models/user-permissions';
import { UserPermissions } from 'app/modules/main/models/user-permissions';
import { AncillaryEndpointsService } from 'app/modules/main/services/ancillary-endpoints.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

interface PermissionsResponse {

  resultSet: {

    accountId: number,
    linkedAccountId: number,
    type: string,

    scopes: string[],

  }[],

}

@Injectable({ providedIn: 'root' })
export class UserPermissionsService {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: AncillaryEndpointsService,
  ) {
  }

  fetch(
    access: Access
  ): Observable<UserPermissions> {

    const url =
      this.serviceEndpoints.accountPermissionsUrl
        .replace(':userId', access.userId);

    return this.http.get<PermissionsResponse>(url)
      .pipe(map(response => this.toUserPermissions(access.userId, response)));
  }

  private toUserPermissions(
    userId: string,
    response: PermissionsResponse
  ): UserPermissions {

    const accounts =
      response.resultSet
        .map(permissions => this.toAccountPermissions(permissions))
        .filter(x => !!x);

    return {
      userId,
      accounts,
    };
  }

  private toAccountPermissions(
    permissions
  ): AccountPermissions {

    return {
      account: {
        accountId: +permissions.linkedAccountId,
        accountType: this.toAccountType(permissions.type),
      },
      scopes:
        permissions.scopes
          .map(scope => scope.trim())
          .filter(scope => !!scope),
    };
  }

  private toAccountType(
    responseAccountType: string
  ): AccountType {

    switch (responseAccountType.toLowerCase()) {

      case 'advertiser':
        return AccountType.ADVERTISER;

      case 'publisher':
        return AccountType.PUBLISHER;

      default:
        return AccountType.UNRECOGNISED;
    }
  }

}
